module.exports = __webpack_public_path__ + "static/img/iconfont.498176e.svg";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/iconfont.svg?t=1559020008880
// module id = vpjx
// module chunks = 96